import * as classNames from "classnames";
import * as React from 'react';
import { withTheme } from '../common/withTheme';
import * as Configuration from '../configuration';
import Login from './Users/Login';
import { bindActionCreators } from "redux";
import { IAppState } from "../app";
import * as LoginActionCreators from "../actions/login.actions";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import LoginSmall from "./Users/LoginSmall";
import InternalAbsoluteLink from "./Framework/Common/Links/InternalAbsoluteLink";


interface IHeaderProps {
    loginActive: boolean;
    currentUser: any;
    className?: string;
    theme?: string;
    bannerName: string;
    userButtonClassnames: string;
}

interface IHeaderActions {
    login?: typeof LoginActionCreators.login;
    logout?: typeof LoginActionCreators.logout;
}

type HeaderProps = IHeaderProps & IHeaderActions;

class Header extends React.PureComponent<HeaderProps, any> {
    constructor(props, context) {
        super(props, context);

        this.onLogoutClick = this.onLogoutClick.bind(this);
    }

    onLogoutClick() {
        this.props.logout();
    }

    render() {
        const bannerName = this.props.bannerName && this.props.bannerName.length > 0 ?
            this.props.bannerName : ''

        const content = <div className={classNames(this.props.theme, this.props.className, "header flex-row d-flex align-items-center px-4")}>
            {InternalAbsoluteLink("/", undefined, undefined, classNames(this.props.theme, "header-logo d-none d-md-block clickable"))}
            <h2 className="col d-none d-md-block my-auto">{bannerName}</h2>

            {this.props.loginActive ?
                <div className={classNames(this.props.theme, "justify-content-end flex-row header-login-wrapper ml-auto ml-md-0")} >
                    <span className="text-white align-middle px-3" style={{ borderColor: "#4C563D", textTransform: "none" }}>
                        <strong>{this.props.currentUser.fullName} {this.props.currentUser.surname}</strong>
                    </span>

                    <Link
                        className={classNames(this.props.theme, this.props.userButtonClassnames, "btn btn-sm mr-1")}
                        to={"/user"}
                    >
                        MY PROFILE
                    </Link>

                    <button type="button" className={classNames(this.props.theme, this.props.userButtonClassnames, "btn btn-sm")} onClick={this.onLogoutClick}>LOGOUT</button>
                </div> : undefined
            }
            {
                !this.props.loginActive ?
                    <LoginSmall
                        className="ml-md-auto col header-login-wrapper"
                        login={this.props.login}
                    />
                    : undefined
            }
        </div>
        return (content);
    }
}

const mapStateToProps = (state: IAppState, ownProps: HeaderProps) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        login: LoginActionCreators.login,
        logout: LoginActionCreators.logout,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme<HeaderProps>(Header));
